/* eslint-disable no-duplicate-imports */
import { resolve } from 'redux-optimist-promise';
import { get } from 'lodash';
import { SYNC_WITH_LOCATION } from 'Store/constants';
import { getSpecificQueryParam } from 'Utils/uri/uriUtils';
import { QUERY_DURATION } from 'Utils/uri/constants';
import { SIGNOUT } from 'Store/user-info/actions/signout';
import { FACETING_SEARCH_REQUEST } from 'Store/faceting/constants';
import { TRIP_INFORMATION_SET_DURATION, DEFAULT_NO_DURATION } from './duration.constants';
type State = number | null | undefined;
type Payload = {
  value: number | null | undefined;
  search?: {
    products: Array<any>;
  };
};
const initialState = null;
export default function tripDurationReducer(
  state: State = initialState,
  { type, payload }: Action<any>,
) {
  switch (type) {
    case SYNC_WITH_LOCATION: {
      const {
        location: { queryParams },
      } = payload as LocationChangePayload;

      if (queryParams[QUERY_DURATION]) {
        return parseInt(queryParams[QUERY_DURATION], 10);
      }

      return state ? state : DEFAULT_NO_DURATION;
    }

    case TRIP_INFORMATION_SET_DURATION:
      const { value } = payload as Payload;

      if (value === DEFAULT_NO_DURATION) {
        return null;
      }

      return Number(value) || state;

    case resolve(FACETING_SEARCH_REQUEST):
      const { search } = payload as Payload;
      const products: Array<any> = search ? search.products : [];
      const durationQueryParam = getSpecificQueryParam(QUERY_DURATION);
      const defaultDuration = durationQueryParam ? Number(durationQueryParam) : state;
      const durationFromPrice = get(products, '0.price.termsAndConditions.duration');
      return durationFromPrice ? Number(durationFromPrice) : defaultDuration;

    case SIGNOUT:
      return initialState;

    default:
      return state;
  }
}
